import {
  APPLICATION_BUNDLE_GET,
  APPLICATION_BUNDLE_GET_LIST,
  APPLICATION_BUNDLE_ARCHIVE,
  APPLICATION_BUNDLE_UNARCHIVE,
  APPLICATION_BUNDLE_LINK,
  APPLICATION_BUNDLE_UNLINK,
  APPLICATION_BUNDLE_SHARE,
  APPLICATION_BUNDLE_CHANGE_OWNER,
  //APPLICATION_BUNDLE_UPDATE,
  APPLICATION_BUNDLE_APPROVE,
  APPLICATION_BUNDLE_REJECT,
  APPLICATION_BUNDLE_DELETE,
  APPLICATION_BUNDLE_SET_SEARCH,
  APPLICATION_BUNDLE_SET_FILTERS,
  APPLICATION_BUNDLE_SET_STATUS,
  APPLICATION_BUNDLE_REQUEST,
  APPLICATION_BUNDLE_SUCCESS,
  APPLICATION_BUNDLE_ERROR
} from "@/store/types"

import axios from "@/store/axios"

const state = {
  bundles: null,
  currentBundle: null,
  isLoading: false,
  error: null,
  totalCount: 0,
  page: 1,
  search: "",
  filters: null,
  status: ""
}

const getters = {
  getApplicationBundles: (state) => state.bundles,
  getApplicationBundleSearchTerm: (state) => state.search,
  getApplicationBundleCurrentPage: (state) => state.page,
  getApplicationBundleTotalCount: (state) => state.totalCount,
  getApplicationBundleStatus: (state) => state.status,
  getCurrentApplicationBundle: (state) => state.currentBundle,
  isApplicationBundleLoading: (state) => state.isLoading,
  getApplicationBundleError: (state) => state.error,
  getApplicationBundleFilters: (state) => state.filters
}

const actions = {
  [APPLICATION_BUNDLE_GET]: ({ commit }, { slug }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .get(`/api/v3/application_bundles/${slug}/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_GET_LIST]: (
    { commit, rootState },
    { status, page = 1, search = "", filters = {} }
  ) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)
      let formattedStatus = ""
      let archived = false

      const context = rootState.user.context

      switch (status) {
        case "submitted":
          formattedStatus = "S,P"
          break
        case "invited":
          formattedStatus = "I,C,U,B"
          break
        case "archived":
          archived = true
          break
        case "decided":
          formattedStatus = "A,R"
          break
        case "accepted":
          formattedStatus = "A"
          break
        case "declined":
          formattedStatus = "R"
          break
        default:
          formattedStatus = ""
      }
      commit(APPLICATION_BUNDLE_SET_STATUS, status)
      commit(APPLICATION_BUNDLE_SET_SEARCH, search)
      commit(APPLICATION_BUNDLE_SET_FILTERS, filters)

      axios
        .get(
          `/api/v3/application_bundles/?page=${page}&is_archived=${archived ? "True" : "False"}${
            formattedStatus ? `&status=${formattedStatus}` : ""
          }${search ? `&search=${search}` : ""}${
            context === "applicant" ? "&context=applicant" : ""
          }${filters.reports ? `&reports=${filters.reports.join(",")}` : ""}`
        )
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          resp.data.page = page
          commit(APPLICATION_BUNDLE_SUCCESS, { bundles: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_DELETE]: ({ commit }, { slugs }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .post(`/api/v3/application_bundles/delete/`, { slugs })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_ARCHIVE]: ({ commit }, { slugs }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .post(`/api/v3/application_bundles/archive/`, { slugs })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_UNARCHIVE]: ({ commit }, { slugs }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .post(`/api/v3/application_bundles/unarchive/`, { slugs })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_LINK]: ({ commit }, { ids }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .post(`/api/v3/application_bundles/group/`, { application_ids: ids })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_UNLINK]: ({ commit }, { slug }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .post(`/api/v3/application_bundles/${slug}/ungroup/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_SHARE]: ({ commit }, { slug, recipients, extraMessage, baseUrl }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)
      const formattedRecipients = recipients.map((r) => {
        // reports: "",
        // decisioning: "",
        // userType: "",
        // email: "",
        // name: ""
        r.user_type = r.userType
        return r
      })

      axios
        .post(`/api/v3/application_bundles/${slug}/share/`, {
          recipients: formattedRecipients,
          extra_message: extraMessage,
          base_url: baseUrl
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS, { bundle: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_APPROVE]: ({ commit }, { slug, sendEmail, cc, subject, customMessage }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .post(`/api/v3/application_bundles/${slug}/accept/`, {
          with_email: sendEmail,
          subject,
          email_body: customMessage,
          cc_self: cc
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_REJECT]: (
    { commit },
    { slug, reasons, adverseAction, sendEmail, cc, subject, customMessage }
  ) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .post(`/api/v3/application_bundles/${slug}/reject/`, {
          adverse_action: adverseAction,
          reasons,
          with_email: sendEmail,
          subject,
          email_body: customMessage,
          cc_self: cc
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUNDLE_CHANGE_OWNER]: ({ commit }, { username, bundles }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_BUNDLE_REQUEST)

      axios
        .post("/api/v3/application_bundles/change_owner/", {
          username,
          bundles
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_BUNDLE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_BUNDLE_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [APPLICATION_BUNDLE_REQUEST]: (state) => {
    state.isLoading = true
  },
  [APPLICATION_BUNDLE_SET_STATUS]: (state, status) => {
    state.status = status
  },
  [APPLICATION_BUNDLE_SET_SEARCH]: (state, searchTerm) => {
    state.search = searchTerm
  },
  [APPLICATION_BUNDLE_SET_FILTERS]: (state, filters) => {
    state.filters = filters
  },
  [APPLICATION_BUNDLE_SUCCESS]: (state, { bundles, current, bundle } = {}) => {
    state.isLoading = false

    if (bundles) {
      state.bundles = bundles.results
      state.page = bundles.page
      state.totalCount = bundles.count
    }
    if (bundle) {
      state.bundles = [
        bundle,
        ...(state.bundles?.filter((b) => b.slug !== bundle.slug) || [])
      ].filter(Boolean)
    }
    if (current !== undefined) state.currentBundle = current
  },
  [APPLICATION_BUNDLE_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err.message
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
